import LoadingSpinnerSmall from 'components/Common/LoadingSpinner/LoadingSpinnerSmall'
import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const DeleteModal = ({ show, onDeleteClick, onCloseClick, loading, error, userStatus }) => {
  const inativar = userStatus === 1
  return (
    <Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className={`avatar-title ${inativar ? "bg-danger" : "bg-success"} bg-opacity-10 font-size-20 rounded-3`} style={{ color: inativar ? "#f46a6a" : "#34c38f" }}>
              <i className={`mdi ${inativar ? "mdi-account-cancel" : "mdi-account-check"}`}></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">
            {inativar
              ? "Deseja inativar este usuário?"
              : "Deseja reativar este usuário?"}
          </p>

          <div className="hstack gap-2 justify-content-center mb-0">
            {loading ? <div className='mr-4'><LoadingSpinnerSmall /></div> : (
              <button
                type="button"
                className={`btn ${inativar ? "btn-danger" : "btn-success"}`}
                onClick={onDeleteClick}
              >
                {inativar ? "Inativar" : "Ativar"}
              </button>
            )}
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>Cancelar</button>
          </div>
          {error ? <p className='mt-4 text-danger'>Houve um erro ao atualizar o status do usuário.</p> : ""}
        </ModalBody>
      </div>
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  loading: PropTypes.bool,
  error: PropTypes.any,
  userStatus: PropTypes.number,
}

export default DeleteModal
